/** @format */
import { css } from 'styled-components';

import { BlackoutProps } from './index';

/**
 * Base styles for the blackout component
 *
 * @param {BlackoutProps} props The blackout properties object
 * */
const baseStyles = (props: BlackoutProps) => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: var(--colors-overlay-base);
    z-index: 9998;
`;

/**
 * The blackout component styles
 *
 * @param {BlackoutProps} props The blackout properties object
 * */
export const styles = (props: BlackoutProps) => css`
    ${baseStyles(props)}
`;
